<script setup lang="ts">
  import { inject, ref, computed, watch } from 'vue'
  import { useI18n } from 'vue-i18n'
  import CloseIcon from '../CloseIcon.vue'
  const props = withDefaults(defineProps<Props>(), {
    minimal: false,
    showClose: false,
    showButton: false,
    btnText: null,
    overflowOff: false,
    popupSmall: false,
    supportPopup: false,
  })

  const emit = defineEmits<Emits>()

  defineOptions({
    name: 'BasePopupWrapper',
  })

  interface Props {
    minimal?: boolean
    showClose?: boolean
    showButton?: boolean
    btnText?: string | null
    overflowOff?: boolean
    popupSmall?: boolean
    supportPopup?: boolean
  }
  interface Emits {
    (e: 'close'): void
  }

  const { t } = useI18n()
  const localeRTL = inject<LocaleType>('localeRTL')

  const isOpen = ref(false)

  const closeBtnText = computed(() => props.btnText ?? t('qic_close'))

  const open = () => {
    isOpen.value = true
  }
  const close = () => {
    isOpen.value = false
    emit('close')
  }

  watch(
    () => isOpen.value,
    (newValue) => {
      const cssClass = 'overflow-off'
      const method = newValue ? 'add' : 'remove'
      document.body.classList[method](cssClass)
    }
  )

  defineExpose({
    open,
  })
</script>

<template>
  <Teleport to="body">
    <transition name="fade">
      <div
        v-if="isOpen"
        class="popup"
        :class="{
          'popup--overflow-off': overflowOff,
          popupSmall,
          'support-popup': supportPopup,
          rtl: localeRTL,
        }"
      >
        <div class="modalContent">
          <div v-if="!minimal || showClose" class="closeBlock">
            <i class="close" @click="close">
              <CloseIcon />
            </i>
          </div>

          <div class="popup-content">
            <slot :close="close"></slot>
          </div>

          <div v-if="!minimal || showButton" class="termsPopup__close">
            <button
              class="btn btn-second btn-second_medium popup__btn"
              data-test="close-button"
              @click="close"
            >
              {{ closeBtnText }}
            </button>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="isOpen" class="popup__bg" @click="close"></div>
    </transition>
  </Teleport>
</template>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.15s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
    transition: opacity 0.05s;
  }
</style>
